import getValidationError from '@assetsJsModule/dropzone/service/getValidationError';

import {
    maxNumberOfFiles,
    maxTotalFilesSize,
    allowedMimeTypes,
    BUSINESS_DEVELOPMENT_VALIDATION_SCHEMA,
    SUPPORT_VALIDATION_SCHEMA,
    RECIPIENTS,
    RULES,
} from '../config/constants';

const getValidationSchema = recipient => (
    recipient === RECIPIENTS.support
        ? SUPPORT_VALIDATION_SCHEMA
        : BUSINESS_DEVELOPMENT_VALIDATION_SCHEMA
);

const validateField = (value, rules) => {
    for (const { rule, value: ruleValue } of rules) {
        const validator = RULES[rule];

        if (!validator) {
            continue;
        }

        const error = validator(value, ruleValue);

        if (error) {
            return error;
        }
    }

    return null;
};

export const validate = (values, props) => {
    const { t, recipient } = props;
    const errors = {};

    Object.entries(getValidationSchema(recipient)).forEach(([fieldName, rules]) => {
        const errorKey = validateField(values[fieldName], rules);

        if (errorKey) {
            errors[fieldName] = t(errorKey);
        }
    });

    const attachmentError = getValidationError(
        values.attachments || [],
        maxNumberOfFiles,
        maxTotalFilesSize,
        allowedMimeTypes,
    );

    if (attachmentError) {
        errors.attachments = attachmentError;
    }

    return errors;
};
